export enum NavbarElement {
  HomeLink = 'HomeLink',
  DashboardLink = 'DashboardLink',
  AddForFreeButton = 'AddForFreeButton',
  DisplayLanguageSwitcherButton = 'DisplayLanguageSwitcherButton',
}
